<template>
    <CHeader fixed with-subheader light>
        <CHeaderBrand class="mx-auto d-lg-none" to="/">
            <CIcon name="logo" height="38" alt="Logo" />
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
        <CHeaderNav class="mr-4">
            <TheHeaderDropdownAccnt />
        </CHeaderNav>
    </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt';
import { mapMutations } from 'vuex';

export default {
    name: 'TheHeader',
    components: {
        TheHeaderDropdownAccnt,
    },
    methods: {
        ...mapMutations('sidebar', ['toggleSidebarDesktop', 'toggleSidebarMobile']),
    },
};
</script>
